import React from 'react';
import Div from "@jumbo/shared/Div";
import Link from "@mui/material/Link";
import {ASSET_IMAGES} from "../../utils/constants/paths";
import { useLocation } from 'react-router-dom';


const Logo = ({mini, mode, sx}) => {

    const location = useLocation();
    const icon = localStorage.getItem("ICON");
    return (
        <Div sx={{display: "inline-flex", ...sx}}>
            {location.pathname.includes("superadmin") ? 
            (<Link href={'/superadmin/apps'}>
                {
                    // !mini ?
                    //     <img src={ mode === "light" ? `${ASSET_IMAGES}/logo.png` : `${ASSET_IMAGES}/logo-white.png`} alt="Trexo Global" width="100%"/>
                    //     :
                    //     <img src={mode === "light" ? `${ASSET_IMAGES}/logo-short.png` : `${ASSET_IMAGES}/logo-short-white.png`} alt="Trexo Global" width="100%" />

                    <img src = {`/images/TG_white_logo.png`} alt="Trexo Global" width="100%" />
                }
            </Link>) :

            (<Link href={'/dashboard'}>
            {
                // !mini ?
                //     <img src={ mode === "light" ? `${ASSET_IMAGES}/logo.png` : `${ASSET_IMAGES}/logo-white.png`} alt="Trexo Global" width="100%"/>
                //     :
                //     <img src={mode === "light" ? `${ASSET_IMAGES}/logo-short.png` : `${ASSET_IMAGES}/logo-short-white.png`} alt="Trexo Global" width="100%" />

                <img src = {icon} alt="Trexo Global" width="100%" />
            }
        </Link>)
            }
        </Div>
    );
};

Logo.defaultProps = {
    mode: "light"
};

export default Logo;
